import React, {useEffect, useRef, useState} from 'react';
import { Link } from "react-router-dom";
import {decodeJWT, getCurrentToken, isTokenExpired} from "../../../helpers/accessTokenHelper.js";
import clientsService from "../../../services/clientsService.js";
import customMenuService from "../../../services/customMenuService.js";

const SidebarNav = () => {

    const didFetchClient = useRef(false);
    const [showParametros, setShowParametros] = useState(false);
    const [showHomeSubmenu, setShowHomeSubmenu] = useState(false);
    const [logo, setLogo] = useState(null);
    const [customMenu, setCustomMenu] = useState([]);
    const [clientTitle, setClientTitle] = useState('');

    const loadingCustomMenu = () => {
        customMenuService.getCustomMenu().then(data => {
            setCustomMenu(data);
        });
    }

    const toggleParametros = () => {
        setShowParametros(!showParametros);
    };

    const toggleHomeSubmenu = () => {
        setShowHomeSubmenu(!showHomeSubmenu);
    };

    const logout = () => {
        if (window.confirm('¿Estás seguro que deseas cerrar la sesión?')) {
            localStorage.clear();
            window.location.reload();
        }
    };

    useEffect(() => {
        const storeToken = getCurrentToken();
        if(!isTokenExpired(storeToken)){
            const decodedToken = decodeJWT(storeToken);
            if (decodedToken.data.client_id) {
                if (!didFetchClient.current) {
                    didFetchClient.current = true;
                    clientsService.getClient(decodedToken.data.client_id).then(response => {
                        if(response.success){
                            setClientTitle(response.data.name);
                        }
                        try {
                            if(response.data.logo){
                                setLogo(response.data.logo);
                            }
                        } catch {}
                    });
                }
                loadingCustomMenu();
            }
        }
    },[]);

    return (
        <div className="col-md-3 col-lg-2 bg-dark text-white p-4">

            {logo && (
                <div className="logo-sidebar">
                    <Link to="/dashboard">
                        <img src={logo} className="logo-login-top" alt="GeoTrace" />
                    </Link>
                </div>
            )}

            {!logo && (
                <div className="logo-sidebar">
                    <Link to="/dashboard">
                        <img src="/logo.png" className="logo-login-top tint-image" alt="GeoTrace" />
                    </Link>
                </div>
            )}

            <ul className="nav flex-column">
                <li className="nav-item dropdown position-relative" onMouseEnter={toggleHomeSubmenu} onMouseLeave={toggleHomeSubmenu}>
                    {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                    <a className="nav-link text-white" href="#" role="button">
                        <i className="bi bi-house"></i> Home <i className="bi bi-chevron-right"></i>
                    </a>
                    <ul className={`dropdown-menu bg-dark position-absolute start-100 width-100 top-0 ${showHomeSubmenu ? 'show' : ''}`}>
                        <li>
                            <Link className="nav-link text-white" to="/dashboard">
                                <i className="bi bi-house"></i> Dashboard
                            </Link>
                        </li>
                        {Array.isArray(customMenu) && customMenu.map((item) => (
                            <li key={item.id}>
                                <Link className="nav-link text-white" to={item.url}>
                                    <i className={`bi ${item.icon}`}></i> {item.name}
                                </Link>
                            </li>
                        ))}
                    </ul>
                </li>
                <li className="nav-item">
                    <Link className="nav-link text-white" to="/proyectos">
                        <i className="bi bi-briefcase"></i> Proyectos
                    </Link>
                </li>
                <li className="nav-item">
                    <Link className="nav-link text-white" to="/gantt">
                        <i className="bi bi-bar-chart-steps"></i> Gantt
                    </Link>
                </li>
                <li className="nav-item">
                    <Link className="nav-link text-white" to="/actividades">
                        <i className="bi bi-list-task"></i> Actividades
                    </Link>
                </li>
                <li className="nav-item">
                    <Link className="nav-link text-white" to="/perfil">
                        <i className="bi bi-person-fill"></i> Mi Perfil
                    </Link>
                </li>
                <li className="nav-item dropdown position-relative" onMouseEnter={toggleParametros} onMouseLeave={toggleParametros}>
                    {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
                    <a className="nav-link text-white" href="#" role="button">
                        <i className="bi bi-gear"></i> Parámetros <i className="bi bi-chevron-right"></i>
                    </a>
                    <ul className={`dropdown-menu bg-dark position-absolute start-100 top-0 ${showParametros ? 'show' : ''}`}>
                        <li>
                            <Link className="dropdown-item text-white" to="/usuarios">
                                <i className="bi bi-people-fill"></i> Usuarios
                            </Link>
                        </li>
                        <li>
                            <Link className="dropdown-item text-white" to="/datos-personalizados">
                                <i className="bi bi-ui-checks-grid"></i> Campos Personalizados
                            </Link>
                        </li>
                        <li>
                            <Link className="dropdown-item text-white" to="/estados">
                                <i className="bi bi-card-checklist"></i> Estados
                            </Link>
                        </li>
                        <li>
                            <Link className="dropdown-item text-white" to="/menus-personalizados">
                                <i className="bi bi-menu-button-fill"></i> Menús Personalizados
                            </Link>
                        </li>
                        <li>
                            <Link className="dropdown-item text-white" to="/pages">
                                <i className="bi bi-card-heading"></i> Páginas personalizadas
                            </Link>
                        </li>
                    </ul>
                </li>
            </ul>

            <button className="logout-btn btn bg-success" style={{width: '100%'}} onClick={logout}>Cerrar Sesión</button>

            <div className="text-center">
                <img src="/logo-footer.png" className="logo-login-bottom tint-image" alt="GeoTrace" />
            </div>

        </div>
    );
};

export default SidebarNav;